import BasePcWorkbenchLoader from '@framework/workbench/loader/base/base-pc-loader';
import ArkLoader from '@src/js/common/ark-extensions';
import { isEditableDriveFile } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import { extensionServiceAdapter } from '@tencent/docs-titlebar-service';
import { getPathname, getU } from '@tencent/ark-utils/lib/location';
import { DomainInitRequestsParam } from '@tencent/ark-domain/lib/base/domain-service/domain-service.interface';
import { IPlatformSetting, IWorkbenchSettings, IWorkbench, MiddlewareService, EventEmitter } from '@tencent/workbench';
import TocPcWorkbenchSetting from '@framework/workbench/setting/toc/toc-pc-setting';
import { isLogin } from '@src/js/common/utils';
import { ToolbarType } from '@src/js/constant';

/**
 * 提供toc基础编辑器能力的loader。
 * 由toc衍生的私有化和web office可以直接继承此类进行扩展
 */
export default class TocEditPcWorkbenchLoader extends BasePcWorkbenchLoader {
    public constructor(
        workbench: IWorkbench,
        eventEmitter: EventEmitter,
        middlewareService: MiddlewareService,
    ) {
        super(workbench, eventEmitter, middlewareService);
    }

    public $onInit() {
        super.$onInit();
        this.initExtensionServiceAdapter();
    }

    /**
     * 创建workbench的settings配置
     * @protected
     */
    protected createSettings(): IWorkbenchSettings<IPlatformSetting> {
        return new TocPcWorkbenchSetting().createSettings();
    }

    /**
     * 初始化组件titlebar需要的extensionService
     */
    protected initExtensionServiceAdapter() {
        const {
            docMetaDomain,
            authDomain,
            userInfoDomain,
            accountDomain,
            fileInfoDomain,
            collaborateDomain,
        } = ArkLoader.extensionService.dependentServiceCombinder;

        // fileInfoDomain 主动调用 init 方法，云编文档的统一顶部栏依赖此数据
        if (isEditableDriveFile()) {
            const pathname = getPathname(); // 形如 '/pdf/DRmpTd0FSekhtclF3'
            const docId = pathname.slice(pathname.lastIndexOf('/') + 1); // 形如 'DRmpTd0FSekhtclF3'
            const u = getU();
            const initParam: DomainInitRequestsParam = { docId, u };
            fileInfoDomain.init(initParam);
        }

        extensionServiceAdapter.updateExtensionService(ArkLoader.extensionService);
        extensionServiceAdapter.updateDomainService({
            collaborateDomain,
            docMetaDomain,
            authDomain,
            userInfoDomain,
            accountDomain,
            fileInfoDomain,
        });
    }

    protected hidePreContainer() {
        super.hidePreContainer();
        // 账号未登录时 统一顶部栏内登录按钮是加载的dc组件 需延缓隐藏pre-dom时机
        const timeout = isLogin() ? 100 : 2000;
        setTimeout(() => {
            const pcContainer: NodeListOf<HTMLElement> = document.querySelectorAll('.pre-header-toolbar-control');
            pcContainer?.forEach(ele => ele.parentElement?.removeChild(ele));
            // 根据工具栏类型调整 localLoginTip 位置（因层级问题，初始化加载时会隐藏localLoginTip组件）
            const localLoginTipElement: HTMLElement | null  = document.querySelector('#workbench-titlebar .local-login-tip');
            if (localLoginTipElement) {
                const toolbarMode = this.getAppService().viewableServiceLayer.toolbarStateManager.getToolbarMode();
                if (toolbarMode === ToolbarType.SINGLE_TOOLBAR) {
                    localLoginTipElement.style.top = '108px';
                }
                localLoginTipElement.style.display = 'flex';
            }
        }, timeout);
    }
}
